import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import ThinWarningIcon from '~/components/SVG/ThinWarning.svg?react';

interface ThinWarningProps {
  className?: string;
  onClick?: () => void;
  'aria-label'?: string;
  sx?: SxProps<Theme>;
}

const ThinWarning = ({ sx, ...props }: ThinWarningProps) => {
  return <Box component={ThinWarningIcon} sx={sx} {...props} />;
};

export default ThinWarning;
